import styled from 'styled-components'

const PageHeaderSimpleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  width: 100%;
  background: ${({ theme }) => theme.colorBgContainer};
  height: 100%;
`

export default PageHeaderSimpleWrapper
